import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaVuejs,
  FaAngular,
  FaNodeJs,
  FaDatabase,
  FaSass,
  FaDocker,
  FaAws,
  FaJava,
  FaGitAlt,
  FaRegFilePdf,
  FaFigma,
} from "react-icons/fa";
import {
  SiMongodb,
  SiExpress,
  SiWebpack,
  SiTypescript,
  SiSpring,
  SiPostgresql,
  SiHeroku,
  SiNetlify,
  SiRuby,
  SiRubyonrails,
  SiPython,
  SiNewrelic,
  SiMysql,
  SiOracle,
  SiLaravel,
  SiSonarqube,
  SiKotlin,
  SiPhp,
  SiVisualbasic,
  SiVisualstudio,
  SiVisualstudiocode,
  SiRubymine,
  SiEclipseide,
  SiIntellijidea,
  SiGithub,
  SiGitlab,
  SiBitbucket,
  SiCircleci,
  SiJira,
  SiTrello,
  SiElasticsearch,
  SiMagento,
  SiRedis,
  SiGnubash,
  SiFlask,
  SiFastapi,
  SiDjango,
  SiFirebase,
  SiJest,
  SiMicrosoftsqlserver,
  SiSqlite,
  SiMariadb,
  SiPostman,
  SiGrafana,
  SiUipath,
  SiRabbitmq,
  SiSelenium,
  SiApachekafka,
  SiApachetomcat,
  SiApachenetbeanside,
  SiCsharp,
  SiAzuredevops,
} from "react-icons/si";
import { RiAngularjsFill } from "react-icons/ri";
import { GiFox } from "react-icons/gi";
import { DiScrum, DiAndroid, DiNginx } from "react-icons/di";
import { TbSql } from "react-icons/tb";

// Mapa de nombre de tecnología -> componente de ícono, usado para las
// "Tecnologías utilizadas" de cada experiencia laboral.
const iconMap = {
  HTML: FaHtml5,
  CSS: FaCss3Alt,
  JavaScript: FaJs,
  React: FaReact,
  "Vue.js": FaVuejs,
  Angular: FaAngular,
  "Node.js": FaNodeJs,
  Databases: FaDatabase,
  MongoDB: SiMongodb,
  Express: SiExpress,
  Sass: FaSass,
  Webpack: SiWebpack,
  TypeScript: SiTypescript,
  Docker: FaDocker,
  AWS: FaAws,
  Java: FaJava,
  Spring: SiSpring,
  Git: FaGitAlt,
  PostgreSQL: SiPostgresql,
  Heroku: SiHeroku,
  Netlify: SiNetlify,
  Ruby: SiRuby,
  "Ruby on Rails": SiRubyonrails,
  Python: SiPython,
  "New Relic": SiNewrelic,
  MySQL: SiMysql,
  Oracle: SiOracle,
  Laravel: SiLaravel,
  SonarQube: SiSonarqube,
  Kotlin: SiKotlin,
  PHP: SiPhp,
  "Visual Basic": SiVisualbasic,
  "Visual Studio": SiVisualstudio,
  "Visual Studio Code": SiVisualstudiocode,
  RubyMine: SiRubymine,
  "Eclipse IDE": SiEclipseide,
  "IntelliJ IDEA": SiIntellijidea,
  GitHub: SiGithub,
  GitLab: SiGitlab,
  Bitbucket: SiBitbucket,
  CircleCI: SiCircleci,
  Jira: SiJira,
  Trello: SiTrello,
  Elasticsearch: SiElasticsearch,
  Magento: SiMagento,
  Redis: SiRedis,
  "GNU Bash": SiGnubash,
  AngularJS: RiAngularjsFill,
  Scrum: DiScrum,
  "Visual Fox": GiFox,
  JasperReports: FaRegFilePdf,
  Android: DiAndroid,
  Flask: SiFlask,
  FastAPI: SiFastapi,
  Django: SiDjango,
  Firebase: SiFirebase,
  Jest: SiJest,
  SQLServer: SiMicrosoftsqlserver,
  SQLite: SiSqlite,
  SQL: TbSql,
  MariaDB: SiMariadb,
  Postman: SiPostman,
  Grafana: SiGrafana,
  UIpath: SiUipath,
  RabbitMQ: SiRabbitmq,
  Selenium: SiSelenium,
  Kafka: SiApachekafka,
  Tomcat: SiApachetomcat,
  Netbeans: SiApachenetbeanside,
  Nginx: DiNginx,
  Figma: FaFigma,
  "C#": SiCsharp,
  "Azure DevOps": SiAzuredevops,
  SSIS: SiMicrosoftsqlserver,
  JavaFX: FaJava,
};

export const getTechIcon = (tech) => {
  const IconComponent = iconMap[tech] || FaDatabase;
  return <IconComponent className="text-2xl mr-2" />;
};
